import React from 'react'
import { Card } from 'react-bootstrap'

const Address = () => {

    const [formData, setFormData] = React.useState({});

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };


    return (
        <>
            <div className="section ">
                <div className="">
                    <div style={{
                        background: "var(--surface)",
                        border: "1px solid var(--border)",
                        borderRadius: "0px 0px 14px 14px",
                        padding: "20px 22px",
                    }}>
                        <div style={{ marginBottom: 16 }}>
                            <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: 0 }}>Shipping Address</h3>
                            <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>Update your shipping address information</p>
                        </div>


                        <div className="oms-form-grid">

                            <div className="oms-form-group">
                                <label className="oms-form-label">Shipping Address</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter shipping address"
                                    value={formData.shippingAddress || ""}
                                    onChange={(e) =>
                                        handleChange("shippingAddress", e.target.value)
                                    }
                                />
                            </div>

                            <div className="oms-form-group">
                                <label className="oms-form-label">Postal Code / PO Box </label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter postal code or PO box"
                                    value={formData.postalCode || ""}
                                    onChange={(e) =>
                                        handleChange("postalCode", e.target.value)
                                    }
                                />
                            </div>

                        </div>

                        <div className='mt-3 text-end '>
                            <button
                                className='oms-btn oms-btn-primary'
                                size='sm'
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Address